import {PageTitle} from '../../../_metronic/layout/core';
import {useIntl} from 'react-intl';
import Services from '../Components/Services';
import {useQuery} from 'react-query';
import {ListService} from '../Types/service';
import {getServicesByClient} from '../Api/api';
import {useGetMe} from '../../../app/hooks/useGetMe';
import {isClientCIS} from '../../Auth/Utils/CustomerHelper';
import ComingSoon from '../../../app/common/components/ComingSoon';

const BaiesPage = (): JSX.Element => {
  const intl = useIntl();
  const customer = useGetMe();
  const {isLoading, data: services} = useQuery<ListService[]>(['get-service-by-client-baies'], () =>
    getServicesByClient('BAY')
  );

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.CLOUD.GROUP_INFRA'})}</PageTitle>
      {isClientCIS(customer) ? (
        <Services
          isLoading={isLoading}
          services={services}
          title={intl.formatMessage({id: 'MENU.CLOUD.BAYS'})}
          enableRowDetail
          showConnexionInsights={false}
          stackMobileStatusBadge
          detailRoute={(service) => `/services/baies/details?serviceId=${service.serviceId}`}
        />
      ) : (
        <ComingSoon title="MENU.CLOUD.GROUP_INFRA" />
      )}
    </>
  );
};

export default BaiesPage;
